function CarViewController(gridletService, CommonService, userViewService, $state, __env) {
  const ctrl = this;
  const env = __env;
  const getSelectedTrain = CommonService.getSelectedTrain;
  const getSelectedCar = CommonService.getSelectedCar;

  ctrl.$onInit = () => {
    ctrl.view = 'carView';
    ctrl.hasCrewNo = env.profile !== 'VALE' && env.profile !== 'DEMO';
    ctrl.customMelco = env.profile === 'MELCO';
    ctrl.customizable = gridletService.getCustomizable();
    ctrl.selectedTrain = getSelectedTrain();
    ctrl.selectedCar = getSelectedCar();
};

  ctrl.goBack = () => {
    $state.go(userViewService.getPreviousView());
  };
}

angular
  .module('configuration-management.module')
  .controller('CarViewController', CarViewController);
